import axios from './axios';
import SETTINGS from '../settings'
export default {
    addBookmark(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/userbookmarkcontent`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    removeBookmark(id, cb) {
        axios.delete(`${SETTINGS.API_BASE_PATH}/userbookmarkcontent/${id}`).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}